import { useOnOff } from './useOnOff';
export function useToggle(initialValue = false) {
    const [isOn, , , toggle] = useOnOff(initialValue);
    return [isOn, toggle];
}
//# sourceMappingURL=useToggle.js.map